import { handleFetchError } from "./fetch_utils.js";

let notificationCount = 0;

export function loadUserNotifications(notificationMenu){
    // the navbar only renders the menu for signed-in users, so public pages have nothing to load
    if (!notificationMenu){
        return;
    }
    fetch('/api/current_user/notifications?unseenOnly=true')
        .then(resp => {
            if (!resp.ok){
                throw new Error("Error getting notifications");
            }
            return resp.text();
        })
        .then(html => {
            notificationMenu.innerHTML = html;

            const notificationItems = notificationMenu.querySelectorAll(".notification-item");
            notificationCount = notificationItems.length;
            const extraDiv = notificationMenu.querySelector('#extra-notifications-div');
            if (extraDiv){
                notificationCount += Number(extraDiv.dataset.ppcNumberExtra);
            }
            updateNotificationBadge(notificationMenu);

            notificationItems.forEach(ni => {
                ni.addEventListener('click', (event) => handleNotificationClick(event, notificationMenu));
            });

            const markAllButton = notificationMenu.querySelector('#mark-all-notifications-seen');
            markAllButton.addEventListener('click', (event) => handleMarkAllClick(event, notificationMenu));
        })
        .catch(handleFetchError);
}

function updateNotificationBadge(notificationMenu){
    const notificationBadge = notificationMenu.parentElement.querySelector("#notification-badge");
    notificationBadge.textContent = notificationCount > 99 ? "99+" : notificationCount.toString();
    notificationBadge.classList.toggle('d-none', notificationCount <= 0);
}

function handleNotificationClick(event, notificationMenu){
    const notificationItem = event.target.closest('.notification-item');
    markNotificationSeen(notificationItem.dataset.ppcNotificationId);

    // links navigate away; plain items are removed so the menu reflects what is left
    if (notificationItem.tagName !== 'A'){
        notificationItem.remove();
    }
    notificationCount = Math.max(notificationCount - 1, 0);
    updateNotificationBadge(notificationMenu);
    if (!notificationMenu.querySelector('.notification-item') && notificationCount === 0){
        showEmptyNotifications(notificationMenu);
    }
}

function handleMarkAllClick(event, notificationMenu){
    // keep the dropdown open so the empty state is visible
    event.stopPropagation();
    const createdUpTo = event.currentTarget.dataset.ppcCreatedUpTo;
    if (createdUpTo){
        markAllNotificationsSeen(createdUpTo);
    }

    notificationMenu.querySelectorAll('.notification-item').forEach(ni => ni.remove());
    notificationCount = 0;
    updateNotificationBadge(notificationMenu);
    showEmptyNotifications(notificationMenu);
}

function showEmptyNotifications(notificationMenu){
    notificationMenu.querySelector('.notifications-empty').classList.remove('d-none');
    notificationMenu.querySelector('#mark-all-notifications-seen').classList.add('d-none');
    notificationMenu.querySelector('#extra-notifications-div')?.remove();
}

// One request for every unread notification up to the newest one shown, including the ones only counted
function markAllNotificationsSeen(createdUpTo){
    fetch('/api/current_user/notifications/seen', {
        method: "PATCH",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({created_up_to: createdUpTo}),
        keepalive: true
    })
        .then(resp => {
            if (!resp.ok){
                throw new Error("Error marking notifications as seen");
            }
        })
        .catch(handleFetchError);
}

function markNotificationSeen(notificationId){
    fetch('/api/current_user/notification', {
        method: "PATCH",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({notification_id: notificationId}),
        // lets the request finish when the click navigates to the notification's link
        keepalive: true
    })
        .then(resp => {
            if (!resp.ok){
                throw new Error("Error marking notification as seen");
            }
        })
        .catch(handleFetchError);
}
